import uuid from 'uuid';
import {
  SCOPE_COMPANY_TYPES,
  SCOPE_CONTACT_TYPES,
  SCOPE_PARENT_COMPANY,
  SCOPE_TOP_LEVEL,
  SCOPE_SPECIFIC_CLIENTS
} from './constants';

export const getGroupedIntentData = (rows, passedFilters) => {
  const { visibilityScope, companyTypes, contactTypes, parentCompanies, topLevels, clients } =
    passedFilters;
  const groupedData = [];

  const groupData = (items, idField) => {
    items.forEach(item => {
      const filteredRows = rows
        .filter(row => row[idField].includes(item.id))
        .map(row => ({
          ...row,
          intentId: row.id,
          id: `${row.id}-${item.id}`
        }));
      if (filteredRows.length) {
        const groupedRow = {
          id: uuid.v4(),
          name: item.name.toUpperCase(),
          isGroup: true
        };
        groupedData.push(groupedRow);
        groupedData.push(...filteredRows);
      }
    });
  };

  switch (visibilityScope) {
    case SCOPE_COMPANY_TYPES:
      if (!companyTypes.length) return rows;
      groupData(companyTypes, 'company_type_ids');
      break;
    case SCOPE_CONTACT_TYPES:
      if (!contactTypes.length) return rows;
      groupData(contactTypes, 'contact_type_ids');
      break;
    case SCOPE_PARENT_COMPANY:
      if (!parentCompanies.length) return rows;
      groupData(parentCompanies, 'parent_company_ids');
      break;
    case SCOPE_TOP_LEVEL:
      if (!topLevels.length) return rows;
      groupData(topLevels, 'top_level_ids');
      break;
    case SCOPE_SPECIFIC_CLIENTS:
      if (!clients.length) return rows;
      groupData(clients, 'company_ids');
      break;
    default:
      return rows;
  }

  return groupedData;
};
